import handlebars from "handlebars";
import { GetAppraisalModel } from "../../../../../all_Interfaces";
import appraisalDetailsTemplate from "../templates/appraisalDetailsTemplate";
import { useAppSelector } from "../../../../../redux/hooks";
import { Appraiser } from "../../../../../redux/slices/Appraiser1Slice";

export const compileAppraisalDetailsTemplate = (
    appraisalData:GetAppraisalModel,appraiser1:Appraiser[]
  ): string => {
    const compiledAppraisalDetailsTemplate = handlebars.compile(appraisalDetailsTemplate);



    let cityStateCountry: string = "";
    cityStateCountry =
      appraisalData.city != undefined && appraisalData.city != ""
        ? appraisalData.city
        : cityStateCountry;

    cityStateCountry =
      appraisalData.state != undefined && appraisalData.state != ""
        ? cityStateCountry + ", " + appraisalData.state
        : cityStateCountry;

    cityStateCountry =
      appraisalData.country != undefined &&
      appraisalData.country != ""
        ? cityStateCountry + ", " + appraisalData.country
        : cityStateCountry;

        
        var appraiser = appraisalData.appraiser1 != null ? appraiser1.find((a:Appraiser) => a.email === appraisalData.appraiser1.email) : new Appraiser();

        const appraiser1DisplayName = appraisalData.appraiser1 != null ? appraisalData.appraiser1.firstName + ", " + appraisalData.appraiser1.lastName : "";
        const assetManagerDisplayName = appraisalData.assetManager != null ? appraisalData.assetManager.firstName + ", " + appraisalData.assetManager.lastName : "";
        const appraisalTemplateData = {
        investmentName: appraisalData.investmentId + " - " + appraisalData.investmentName,
        fund: appraisalData.fundId + ": " + appraisalData.fund,
        assetManager: assetManagerDisplayName,
        cityStateCountry:cityStateCountry,
        appraiser1:appraiser1DisplayName,
        userType:appraiser != undefined ? appraiser.userType : "",
        investmentType:appraisalData.investmentType,
        appraisalFirm: appraisalData.appraiserFirm,
        externalAppraiser: appraisalData.externalAppraiser
    }

    return compiledAppraisalDetailsTemplate(appraisalTemplateData);
  }